import { useTranslation } from 'react-i18next';
export const useCharacterRaceTypes = () => {
    const { t } = useTranslation();
    return [
        { value: 'human', label: t('character.races.human') },
        { value: 'elf', label: t('character.races.elf') },
        { value: 'half_elf', label: t('character.races.half_elf') },
        { value: 'dwarf', label: t('character.races.dwarf') },
        { value: 'gnome', label: t('character.races.gnome') },
        // { value: 'orc', label: t('character.races.orc') },
        { value: 'half_orc', label: t('character.races.half_orc') },
        { value: 'halfling', label: t('character.races.halfling') },
        { value: 'tiefling', label: t('character.races.tiefling') },
        { value: 'dragonborn', label: t('character.races.dragonborn') },
    ];
};
